import { render, staticRenderFns } from "./En_news.vue?vue&type=template&id=582d9e7e&scoped=true"
import script from "./En_news.vue?vue&type=script&lang=js"
export * from "./En_news.vue?vue&type=script&lang=js"
import style0 from "./En_news.vue?vue&type=style&index=0&id=582d9e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582d9e7e",
  null
  
)

export default component.exports